// import $ from 'jquery';
import './../../libs/jquery.accordion';

export default class{

    constructor( options ) {

        this.defaults = {
        	$el   : false
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.$el 			= 	this.options.$el;
        this.namespace  = 'accordion';

		if ( this.$el.length > 0 ){

            this.$el.each(function() {
                $(this).find('.item').accordion({
                    autoClose: 'true',
                    groupElement: '.items',
                    controlElement: '.trigger',
                    contentElement: '.details',
                    transitionSpeed: 500
                });
                if ($(this).find('.item[open="yes"]')) {
                    $(this).find('.item[open="yes"] .trigger').click();
                }

                let $close = $(this).find( '.item .close' );
                if ( $close.length > 0 ){
                    $close.on( 'click', (e)=>{
                        e.preventDefault();
                        $(e.currentTarget).parents( '.item' ).find( '.trigger' ).click()
                    });
                }

            });

		}

    }


    //---------------------------------------- METHODS ---------------------------------------//

    destroy(){

    }

}